<ng-container
  *ngLet="{
    filterable: defaultedFilterable | async,
    filterEmpty: filterEmpty | async,
    filterPositionBottom: defaultedFilterPositionBottom | async,
    disabled: defaultedDisabled | async,
    exact: defaultedExact | async,
    options: defaultedOptions | async,
    nodes: nodesLimited | async,
    notShownCount: notShownCount | async,
    filter: filter | async
  } as vm"
>
  <option-filter
    class="container sneaky-scroll"
    *ngIf="vm.filterable"
    [autoFocus]="true"
    [disabled]="vm.disabled"
    [inputPositionBottom]="vm.filterPositionBottom"
    [filter]="vm.filter"
    [filterEmpty]="vm.filterEmpty"
    (filterChange)="filter.next($event)"
  >
    <ng-container
      *ngTemplateOutlet="optionsTemplate; context: { $implicit: vm.nodes }"
    ></ng-container>
  </option-filter>
  <div class="container" *ngIf="!vm.filterable">
    <ng-container
      *ngTemplateOutlet="optionsTemplate; context: { $implicit: vm.nodes }"
    ></ng-container>
  </div>
  <ng-template #optionsTemplate let-nodes>
    <div>
      <div>
        <ng-container
          *ngTemplateOutlet="nodesTemplate; context: { $implicit: nodes }"
        ></ng-container>
        <div class="more" *ngIf="vm.notShownCount > 0">
          {{ vm.notShownCount }} more... (Search to narrow results)
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #nodesTemplate let-nodes>
    <ng-container *ngFor="let node of nodes; let i = index; trackBy: trackBy">
      <tree-multi-select-node
        *ngIf="
          vm.filter.length == 0 ||
          node.titleHighlightIndices.length ||
          node.subtitleHighlightIndices.length ||
          node.childrenFiltered
        "
        [autoFocus]="i == 0 && !vm.filterable"
        [expandable]="!!node.children.length"
        [disabled]="vm.disabled || isNodeDisabled(node)"
        [selected]="!!node.selected"
        (selectedChange)="select.next([node.id, $event])"
        [indeterminate]="node.selected === null"
        [expanded]="node.childrenFiltered || node.expanded"
        (expandedChange)="expand.next([node.id, !node.expanded])"
        [identifier]="node.id"
        [subtitle]="node.subtitle"
        [subtitleHighlightIndices]="node.subtitleHighlightIndices"
        [title]="node.title"
        [titleHighlightIndices]="node.titleHighlightIndices"
        [count]="node.count"
        [subvertBox]="node.subvertBox"
        [subvertText]="node.subvertText"
        [displayId]="displayId"
        [link]="node.link"
      >
        <ng-container *ngIf="node.childrenFiltered || node.expanded">
          <ng-container
            *ngTemplateOutlet="
              nodesTemplate;
              context: { $implicit: node.children }
            "
          ></ng-container>
        </ng-container>
      </tree-multi-select-node>
    </ng-container>
  </ng-template>
</ng-container>
